import { SVCurrencyInput } from '@/components/core';
import { PROGRAM_SETTINGS } from '@/constants/programSettings';
import { Grid, Stack, Typography } from '@mui/material';

export const WireControls = () => {
  const {
    PROGRAM_LEVEL_MAX_OUTGOING_WIRE,
    BANK_ACCOUNT_LEVEL_MAX_OUTGOING_WIRE,
    TRANSACTION_LEVEL_MAX_OUTGOING_WIRE,
    UNDER_REVIEW_WIRE_CONTROLS,
  } = PROGRAM_SETTINGS.WIRE_CONTROLS;

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Typography component="h6" fontWeight="bold" mb={2}>
          Program Level Daily Limits
        </Typography>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="wireOutProgramLimitPerRollingDay"
            label={PROGRAM_LEVEL_MAX_OUTGOING_WIRE.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (24 hour rolling aggregate)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ mt: { xs: 0, md: 6 } }}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="wireOutAccountLimitPerCalendarDay"
            label={BANK_ACCOUNT_LEVEL_MAX_OUTGOING_WIRE.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (Calendar Day EST Aggregate)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Typography component="h6" fontWeight="bold" mb={2}>
          Transaction Level Limits
        </Typography>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="wireOutLimitPerTransaction"
            label={TRANSACTION_LEVEL_MAX_OUTGOING_WIRE.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (Per Transaction)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ mt: { xs: 0, md: 6 } }}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="wireRequestReviewThreshold"
            label={UNDER_REVIEW_WIRE_CONTROLS.LABEL}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};
